module["exports"] = [
  "Slovensko"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/address/default_country.js
// module id = 2037
// module chunks = 0